import {
  useCallback 
} from "react";
import {
  useApolloClient 
} from "@apollo/client";

export const useAwaitQuery = query => {
  const apolloClient = useApolloClient();

  return useCallback(
    async options => {
      const res = await apolloClient.query({
        ...options,
        query
      });

      return res;
    },
    [apolloClient, query]
  );
};
